window.$ = window.jQuery = require('jquery')
require('jquery-ui/ui/widgets/slider')
require('jquery-ui/ui/widgets/accordion')
require('jquery-ui/ui/widgets/checkboxradio')
require('jquery-ui-touch-punch')
require('jquery-validation')
require('imask')
require('./slider')
require('./input')
require('./accordion')
require('./menu')
require('./messages_sv')
require('./validation')
require('./personal_id')
require('./limited-input')
require('./loader')
